/** Maps a portal status string to a coloured badge. */
export default function StatusBadge({ status }: { status: string }) {
  const map: Record<string, string> = {
    Draft:             'bg-slate-100 text-slate-700',
    AwaitingSignature: 'bg-amber-100 text-amber-800',
    Pending:           'bg-amber-100 text-amber-800',
    Signed:            'bg-emerald-100 text-emerald-800',
    Completed:         'bg-emerald-100 text-emerald-800',
    Cancelled:         'bg-slate-100 text-slate-500',
    Expired:           'bg-red-100 text-red-700',
  }
  const label: Record<string, string> = {
    Draft:             'Taslak',
    AwaitingSignature: 'İmza bekliyor',
    Pending:           'Bekliyor',
    Signed:            'İmzalandı',
    Completed:         'Tamamlandı',
    Cancelled:         'İptal',
    Expired:           'Süresi doldu',
  }
  const cls = map[status] ?? 'bg-slate-100 text-slate-700'
  return (
    <span className={`inline-block rounded-full px-2.5 py-0.5 text-xs font-medium ${cls}`}>
      {label[status] ?? status}
    </span>
  )
}
